import React, { Fragment } from 'react';
import Footer from '../HomePageFooter';
import HomePageHeader from '../HomePageHeader';
import ImageHeading from './ImageHeading';

const LegalAid = () => {
    const renderSection = () => {
        return (
            <section className='legal pt-5 pb-5'>
                <div className='container'>
                    <div className="row">
                        <div className="pr-heading">
                            <h1>
                                Legal Aid Clinic
                            </h1>
                        </div>
                    </div>
                    <div className='row'>
                        <p className='text-bold w-100'>St. Andrew’s College, Gorakhpur</p>
                        <p className='text-bold w-100'>LEGAL AID CLINIC</p>
                        <p className='text-bold w-100'>(Established under the U.P. state Legal Services Authority)</p>

                        <p>
                            Legal aid is a movement which promotes justice on a basis of equal opportunity to all which implies that opportunities for securing justice are not denied to any citizen by reason of economic or other disability.
                            Tosins end yeee parliament has passed the National Legal Services Authority Act, 1987.
                        </p>

                        <p>
                            Now a nationwide network has been envisaged under the Act for providing Legal aid and assistance on a basis of equal opportunity to all.
                            In every state a state legal services authority is constituted to give effect to the policies and directions of the Central Authority (NALSA) and district legal Services Authority is constituted in every District to implement Legal Aid programmes and schemes in the District.
                        </p>

                        <p>
                            As the St. Andrew’s College Legal Aid Clinic is established to be a part of legal services network under the U.P. State Legal Authority Services network under the U.P. State Legal Services Authority Act.
                            The Legal Aid clinic was inaugurated on 19th October 2013 at 11 a.m. by hon’ble Mr. Justice Shri Narayan Shukla (Allahabad  High Court) Gorakhpur District Judge Mr. Anvind Kumar Mishra Chairman, St. Andrew’s College governing body , The Rt. Rev. Collin C. Theodore, Principal of the college Rev. Prof. J.K. Lal and other dignitaries from the Bench of Bar, Faculty members and students attended the inaugural function, the Moot Court and the Exhibition (Poster Presentation) on Legal Aid which followed.
                            The Moot Court and exhibition (Posters) were highly appreciated by visitors.
                        </p>
                        <p>
                            The St. Andrew’s College through Legal Aid Clinic is committed to provide Legal aid to the poor and weaker sections of the society.
                            Currently it runs by Legal Aid Committee under the due guidance of the Principal of the college, Rev. Prof. J.K. Lal as well as under the supervision and cooperation with District Legal Services Authorities.
                        </p>

                        <h5 className='text-underline w-100'>The Objectives of SAC legal Aid Clinic</h5>
                        <ol className='mt-2'>
                            <li>To develop legal awareness (legal literacy) and skills, which is the first step of effective areas of justice</li>
                            <li>Free legal services</li>
                            <li>Instant advice and information on legal aspects</li>
                            <li>Assist the poor litigants in drafting, typing and presentation of miscellaneous applications</li>
                            <li>Setting the disputes though counseling in order to avoid litigation</li>
                            <li>Encouraging amicable settlement of disputes though lok adalat and mediation</li>
                            <li>Reneging advice for prevention of disputes</li>
                            <li>Assistance in lok adalat</li>
                            <li>To enhance the learning experience of the law students by their involvement in legal aid Activities</li>
                            <li>To do all such things and to perform all such act as may be necessary or proper for the achievement of any or all of the above objects</li>
                        </ol>

                        <h5 className='text-underline mt-3 w-100'>Persons entitled to free legal services</h5>
                        <ol className='mt-2'>
                            <li>Members of Scheduled caste and scheduled tribes</li>
                            <li>Women or children</li>
                            <li>Industrial workers</li>
                            <li>Victims of trafficking in human beings or beggar and other forms of forced labour</li>
                            <li>Mentally ill or disabled personal</li>
                            <li>A person of undeserved want, such as a victim mars disaster, ethnic violence, caste atrocity, flood, drought, earthquake or industrial disaster</li>
                            <li>Persons whose annual income does not exceed Rs. 100,000/-</li>
                            <li>Legal Aid Clinic</li>
                            <li>Faculty of Law</li>
                        </ol>
                    </div>
                </div>
            </section>
        );
    };

    return (
        <Fragment>
            <HomePageHeader isHome={false} />
            <ImageHeading heading={"Legal Aid Clinic"} />
            {renderSection()}
            <Footer />
        </Fragment>
    );
}

export default LegalAid;